import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    statByDate: {
        url: `${customerApi}/api/customer_stat/by_date`,
        type: 'GET',
    },
    statByUser: {
        url: `${customerApi}/api/customer_stat/by_user`,
        type: 'GET',
    },
    exportStatByDate: {
        url: `${customerApi}/api/customer_stat/by_date.xlsx`,
        type: 'GET',
    },
    exportStatByUser: {
        url: `${customerApi}/api/customer_stat/by_user.xlsx`,
        type: 'GET',
    },
}
